import React, { useState } from 'react';
import { IonRow, IonCol, IonCard, IonText, IonIcon, IonButton } from '@ionic/react';
import "./IonUser.scss";
import { Persona } from '../persona/persona';
import { useHistory } from 'react-router';
import { getFormatedRolesWithSemiColon } from '../../../web/pages/userProfile/userProfileUtil';
import MobileNumber from '../../../utils/MobileNumber/MobileNumber';
import { normalizeInput } from '../../../pages/Manage/ManageUser/ManageUserUtil';
import { getDriverFirstLastName, IONICWrapper, isMobile, payloadCreationForReSendInviteNotification} from "../../../utils/common";
import { ASSIGNED_LOADS, ASSIGNED_LOAD_DETAILS, CARRIER_ASSIGNED_MODULE_WEB, MODULES, NEVER_LOGGED_IN, RESEND_INVITE, RE_SEND_INVITE_BUTTON_NAME, RE_SEND_INVITE_FAILURE_MESSAGE, RE_SEND_INVITE_MODAL_MESSAGE, RE_SEND_INVITE_MODAL_TITLE, RE_SEND_INVITE_SUCCESS_MESSAGE } from 'app/utils/constants';
import { isAdminRole, isDispatcherRole } from '../../../utils/roleUtil/RoleUtil';
import { useTranslation } from 'react-i18next';
import { CustomModalWeb } from '../../pages/userProfile/CustomModalWeb';
import { dayjs } from '../../../utils/Date/DateUtil';
import { ToastMessage } from '../../../utils/ToastMessage';
import { reSendInvite } from '../../../actions/manage/action';
import { useDispatch } from 'react-redux';
import { MyLoad } from 'app/models/myLoad/myLoad';
import { fetchShipmentsForDriverInManageUser } from 'app/actions/carrierAssign/action';
import { FetchFromManageUserConfig, myLoadShowMore, showMoreButtonVisiblityWithCount } from 'app/utils/MyLoads.util';
import LoadsList from '../loads-list/LoadsList';

const IonUser: React.FC<any> = (props:any) => {
    const { user ,loads,showLoads,setShowLoads} = props;
    const { push } = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [reSendInviteModalOpen,setReSendInviteModalOpen] = useState<boolean>(false);
    const manageUsersMaxPageSize = FetchFromManageUserConfig("PageSize");
    const loginStatusValue = IONICWrapper?.details?.keys?.configuration?.LoginStatusValue || NEVER_LOGGED_IN;
    const onReSendInvite = ()=>
    {
        setReSendInviteModalOpen(true)
    }
    const reSendInviteModalProps = {
        isModalOpen:  reSendInviteModalOpen,
        title: IONICWrapper?.details?.keys?.configuration?.ResendInviteModalTitle || RE_SEND_INVITE_MODAL_TITLE,
        message :IONICWrapper?.details?.keys?.configuration?.ResendInviteModalMessage || RE_SEND_INVITE_MODAL_MESSAGE,
        aditionalCssClass : "reSendInvite",
        size: "extra_medium_height",
        contentScroll: "deny",
        backdropDismiss:false,
        buttons: [
          {
            title: IONICWrapper?.details?.keys?.configuration?.ResendInviteButtonName || RE_SEND_INVITE_BUTTON_NAME,
            type: "primary-cta-btn-web",
            onClick: () => {
                 setReSendInviteModalOpen(false)
                let payload  = payloadCreationForReSendInviteNotification({
                    upn: user?.upn,
                    email: user?.email,
                    phoneNumber: user?.mobileNumber,
                    carrierName: user?.companyName,
                  });
              
                  const callback = (responseType: string, data: any) => {
                    setReSendInviteModalOpen(false);
                    if (responseType === "success") {
                      if (data?.success === "true") {
                        isMobile
                          ? ToastMessage.show(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteSuccessMessage ||
                                RE_SEND_INVITE_SUCCESS_MESSAGE
                            )
                          : ToastMessage.showWeb(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteSuccessMessage ||
                                RE_SEND_INVITE_SUCCESS_MESSAGE
                            );
                      } else if (data?.success === "false") {
                        isMobile
                          ? ToastMessage.show(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteFailureMessage ||
                                RE_SEND_INVITE_FAILURE_MESSAGE
                            )
                          : ToastMessage.showWeb(
                              IONICWrapper?.details?.keys?.configuration
                                ?.ResendInviteFailureMessage ||
                                RE_SEND_INVITE_FAILURE_MESSAGE
                            );
                      }
                    }
                  };
                  dispatch(
                    reSendInvite({
                      query: payload,
                      callback
                    })
                  );
            
           }
      }
        ]
      };
      const clickDownArrowAction = () => {
        props.setPageIndex(0)
        if (!showLoads) {
          const carrierModel: MyLoad = new MyLoad();
          carrierModel.driverId = user?.upn ? user?.upn : user?.email ? user?.email : user?.mobileNumber;
          carrierModel.pagination = {
            pageSize: manageUsersMaxPageSize,
            pageIndex: 0,
          };
          dispatch(fetchShipmentsForDriverInManageUser(carrierModel.getMyDriverShipments(), false));
          setShowLoads(!showLoads)
          }
          else
          {
            setShowLoads(!showLoads)
          }
      }
    return (
       <>
       <CustomModalWeb {...reSendInviteModalProps}/>
        <IonCard className="singleUserCard">
            <IonRow className="userRow">
            <IonCol className="personaPart" size="1.5" size-lg="1.5">
                <Persona
                    manageUsersFlag={true}
                    name={`${user.firstName} ${user.lastName}`}
                    showName={false}
                />
            </IonCol>
            <IonCol className="mainPart" size="3">
                <div className="driver-manage-size">
                <span className="driver-name-manage">{getDriverFirstLastName(user)}</span>
                </div>
                <div className="driver-role-manage">
                <span>{getFormatedRolesWithSemiColon(user)}</span>
                </div>
                   <div className="view-text">
                <IonRow className="edit-part-manage" onClick={() => {
                    push({pathname: '/app/userProfile', state: {
                        title: "View Profile",
                        selectedUser: user
                    }});
                }}>
                    <IonCol><IonIcon src="assets/icon/view_icon.svg" /> </IonCol>
                    <IonCol><IonText>View</IonText></IonCol>
                </IonRow>
                </div>
            </IonCol>
            <IonCol className="infoPart" size="5.5" size-lg="5">
                <div className="driver-details-manage-height">
                    <span className="driver-details-manage">Email Id</span>{" "}
                    <span className="driver-details-manage">Mobile No</span>
                    {(isAdminRole() || isDispatcherRole()) && (user?.userLastLogin === null ||user?.userLastLogin === undefined || user?.userLastLogin === "") ?
                      <span className="driver-details-manage">Login Status</span>
                      : <span className="driver-details-manage">Last Login</span>
                   }
                </div>
                <div className="driver-data-section">
                    <span className="driver-data-manage">{user?.upn ? user?.upn : user.email}</span>{" "}
                    <span className="driver-data-manage mobile-number">{user.mobileNumber &&
                        <MobileNumber
                            mobileNumber={normalizeInput(user.mobileNumber)}
                            mobileReadOnly={true}
                            name="mobileNumber"
                            placeholder={''}
                            label=''
                            nonEditableField={true}
                            countryCodefromMember={user.mobileNumber.slice(0, -10)}
                        />}
                    </span>
                    {(isAdminRole() || isDispatcherRole()) && (user?.userLastLogin === null ||user?.userLastLogin === undefined || user?.userLastLogin === "") ?
                   <div className="lastLoginValue"> <span className="driver-data-manage">{`${loginStatusValue}  |`}
                   </span>
                   <span className='driver-details-manage resend-invite'onClick={onReSendInvite}>Re-Send Invite</span>
                   </div>
                   : <span className="driver-data-manage">{dayjs( user?.userLastLogin).format("MMM DD, YYYY")}</span>
                    }
                </div>
            </IonCol>
           {user?.canAssignLoad && <IonCol className="buttonPart" size="2.5" size-lg="2.5">
            <IonButton
        className="primary-cta-btn-web assignButton"
        data-test=""
        onClick={() => { push({pathname: CARRIER_ASSIGNED_MODULE_WEB})}}>
        {"Assign Load"}
        </IonButton>
            </IonCol>}
            </IonRow>
            { showLoads  && !props?.loading && <div className='assignedLoadRowDetails-list'>
        {loads?.length > 0 && <div className="assignedLoadRowDetails-display" data-testid="assignedLoadRowDetails-display">
          {ASSIGNED_LOADS}
        </div>}
        <LoadsList
          loads={loads}
          className={"myloads-list"}
          module={MODULES.DRIVER_ASSIGNED_MODULE}
          isCarrierLoad={true}
          isManageUserAssignedLoad ={true}
          searchByReferenceIdManageUser={props.searchByReferenceId}
          fetchShipmentsManageUser={props?.fetchShipmentsManageUser}

        />
         {showMoreButtonVisiblityWithCount(props?.count,
      manageUsersMaxPageSize,props?.page) && loads?.length > 0 && !props?.loading ?
     <IonButton className="btn-common-web" onClick={() =>
      props.paginatedLoads(props?.page+1,user?.upn ? user?.upn : user?.email ? user?.email : user?.mobileNumber)}>
     Show { myLoadShowMore(manageUsersMaxPageSize,loads?.length,props?.count)  } More
   </IonButton>:
      <div className="list-end-banner">
        {!props?.loading && <div className="end-list">
          <div className="left"></div>
         <div className="center">End of list</div>
          <div className="right"></div>
        </div>}
      </div>
        }
        </div> 
        }
         {user?.assignedLoadCount > 0 && <IonRow className="assignedLoadRowDetails">
            <IonRow className='assignedLoadRowDetails-title'  onClick={() => {
            clickDownArrowAction();
          }}>{ASSIGNED_LOAD_DETAILS}</IonRow>
           <IonIcon
            onClick={() => {
            clickDownArrowAction();
          }}
          className={`assignedLoads-downarrow ${showLoads ? "up" : "down"}`}
          data-test="show-loads-arrow"
          src={`assets/icon/grid-${showLoads ? "up" : "down"}-arrow-thin.svg`}
        /></IonRow>
        }
        </IonCard>
       </>
    );
};

export default IonUser;
